<template>
  <div class="fragment">
    <div class="order-create__row custom-row">
      <div class="custom-col custom-col--16 custom-col--sm-50"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate(['fbm_engravingLength'])"></div>
        <DefaultInput
            :label="$t('fbm_engravingLength.localization_value.value')"
            :type="'text'"
            v-bind:class="{'ui-no-valid': FBM.validation.engravingLength}"
            :errorTxt="$t(`${FBM.validationTranslate.engravingLength}.localization_value.value`)"
            :error="FBM.validation.engravingLength"
            v-model="FBM.data.engravingLength"
            @input.native="changeEngravingPrice($event, 'length')"
            @change="calculateEngravingPrice"
        />
      </div>
      <div class="custom-col custom-col--16 custom-col--sm-50"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate(['fbm_engravingWidth'])"></div>
        <DefaultInput
            :label="$t('fbm_engravingWidth.localization_value.value')"
            :type="'text'"
            v-bind:class="{'ui-no-valid': FBM.validation.engravingWidth}"
            :errorTxt="$t(`${FBM.validationTranslate.engravingWidth}.localization_value.value`)"
            :error="FBM.validation.engravingWidth"
            v-model="FBM.data.engravingWidth"
            @input.native="changeEngravingPrice($event, 'width')"
            @change="calculateEngravingPrice"
        />
      </div>
      <div class="custom-col custom-col--16 custom-col--sm-50"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate(['fbm_engravingCount'])"></div>
        <DefaultInput
            :label="$t('fbm_engravingCount.localization_value.value')"
            :type="'text'"
            v-bind:class="{'ui-no-valid': FBM.validation.engravingCount}"
            :errorTxt="$t(`${FBM.validationTranslate.engravingCount}.localization_value.value`)"
            :error="FBM.validation.engravingCount"
            v-model="FBM.data.engravingCount"
            @input.native="changeEngravingPrice($event, 'count')"
            @change="(val) => {calculateEngravingPrice(); $emit('changeQuantity', FBM.data.engravingCustomization, val)}"
        />
      </div>
      <div class="custom-col custom-col--16 custom-col--sm-50"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate(['calculatorEngraving_product',])"></div>
        <DefaultSelect
            :options="engravingCustomOptions"
            :label="$t('calculatorEngraving_product.localization_value.value')"
            :otherValue="'calculatorCustomization'"
            :selected="FBM.data.engravingCustomization"
            @change="changeCustomization"
        />
      </div>
      <div class="custom-col custom-col--16 custom-col--sm-50"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate(['fbm_engravingPrice'])"></div>
        <DefaultInput
            :label="$t('fbm_engravingPrice.localization_value.value')"
            :type="'text'"
            :disabled="true"
            v-model="FBM.data.engravingPrice"
        />
      </div>
    </div>

    <div
        v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
      <div class="admin-edit" @click="editTranslate(['fbm_engravingAcceptFiles1'])"></div>
      {{ $t('fbm_engravingAcceptFiles1.localization_value.value') }}
    </div>
    <div class="order-create__row custom-row">
      <div class="custom-col position-relative"
           v-if="FBM.data.EngravingFile.data.maxCountFiles - Object.keys(FBM.data.EngravingFile.data.downloadFiles).length > 0">
        <DropZone class="drop-zone-bg"
                  :parentFiles="FBM.data.EngravingFile.data.files"
                  :multiple="true"
                  :maxCount="FBM.data.EngravingFile.data.maxCountFiles - FBM.data.EngravingFile.data.downloadFiles.length"
                  :maxSize="FBM.data.EngravingFile.data.maxSizeFiles"
                  @changeImg="(files, maxSize) => {changeFile(files, maxSize)}"
                  :accept="'/*'"
        />
        <div class="error-field ml-3" v-if="FBM.data.EngravingFile.validation.files">
          {{ $t('common_fileIsRequired.localization_value.value') }}
        </div>
      </div>

      <div class="custom-col mt-3"
           v-if="Object.keys(FBM.data.EngravingFile.data.downloadFiles).length > 0"
      >
        <div class="custom-row product-img-row">
          <div class="custom-col custom-col--16 custom-col--md-25 custom-col--sm-100"
               v-for="(item, index) in FBM.data.EngravingFile.data.downloadFiles"
               :key="index">
            <DownloadFileBlock
                :file="item"
                @removeFile="(id) => {removeFile(id, index)}"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DefaultInput from "@/components/UI/inputs/DefaultInput/DefaultInput";
import DownloadFileBlock from "@/components/coreComponents/DownloadFileBlock/DownloadFileBlock";
import DropZone from "@/components/coreComponents/DropZone/DropZone";
import DefaultSelect from "@/components/UI/selectiones/DefaultSelect/DefaultSelect";

export default {
  name: "Engraving",
  components: {DefaultSelect, DefaultInput, DownloadFileBlock, DropZone},

  props: {
    FBM: Object,
    engravingCustomOptions: Array,
  },

  methods: {

    changeCustomization(val) {
      let oldCustomization = this.FBM.data.engravingCustomization
      this.FBM.data.engravingCustomization = val;
      this.calculateEngravingPrice();
      this.$emit('changeCustomization', oldCustomization, val, this.FBM.data.engravingCount)
    },

    removeTenths() {
      // this.FBM.data.engravingLength = ('' + this.FBM.data.engravingLength).replace(',', '.').replace(/[^0-9.]/g, '')
      // this.FBM.data.engravingWidth = ('' + this.FBM.data.engravingWidth).replace(',', '.').replace(/[^0-9.]/g, '')
      // this.FBM.data.engravingCount = ('' + this.FBM.data.engravingCount).replace(',', '.').replace(/[^0-9.]/g, '')

      console.log(this.FBM.data.engravingLength);
      if(('' + this.FBM.data.engravingLength).indexOf('.') > -1) this.FBM.data.engravingLength = this.FBM.data.engravingLength.split('.')[0]
      if(('' + this.FBM.data.engravingWidth).indexOf('.') > -1) this.FBM.data.engravingWidth = this.FBM.data.engravingWidth.split('.')[0]
      if(('' + this.FBM.data.engravingCount).indexOf('.') > -1) this.FBM.data.engravingCount = this.FBM.data.engravingCount.split('.')[0]
    },

    changeEngravingPrice(event, type = false) {

      if(type) {
        switch (type) {
          case 'length':
            this.FBM.data.engravingLength = event.target.value.replace(',', '.').replace(/[^0-9.]/g, '')
            break
          case 'width':
            this.FBM.data.engravingWidth = event.target.value.replace(',', '.').replace(/[^0-9.]/g, '')
            break
          case 'count':
            this.FBM.data.engravingCount = event.target.value.replace(',', '.').replace(/[^0-9.]/g, '')
            break
          default:
            break
        }

        /**
         * Remove Tenths
         */
        this.removeTenths()
      }
    },

    calculateEngravingPrice() {
      if(
          (!this.FBM.data.engravingLength || this.FBM.data.engravingLength.length === 0) ||
          (!this.FBM.data.engravingWidth || this.FBM.data.engravingWidth.length === 0) ||
          (!this.FBM.data.engravingCount || this.FBM.data.engravingCount.length === 0)
      ) {
        return
      }

      let data = {
        offer: this.FBM.data.engravingCustomization ? this.FBM.data.engravingCustomization?.id : null,
        length: this.FBM.data.engravingLength,
        width: this.FBM.data.engravingWidth,
        count: this.FBM.data.engravingCount,
        need_different_engrave: Object.keys(this.FBM.data.EngravingFile.data.downloadFiles).length + this.FBM.data.EngravingFile.getFiles().length > 1,
        need_adjusting_layout: false,
      }

      this.$store.dispatch('getEngravingCalcPriceInOrder', data).then(response => {
        if(this.getRespData(response)?.engraving_cost) {
          this.FBM.data.engravingPrice = parseFloat(this.getRespData(response)?.engraving_cost).toFixed(2)
        }
      })
    },

    changeFile(files, maxSizeError) {
      this.FBM.data.EngravingFile.setFiles(files)

      this.FBM.data.EngravingFile.setFilesMaxSizeError(maxSizeError)

      this.calculateEngravingPrice()
    },

    removeFile(id, index){

      let text = {
        title: 'common_AreYouSure',
        txt: '',
        yes: 'common_confirmDelete',
        no: 'common_confirmNo'
      }

      let confirm = () => {

        this.$store.dispatch('removeUserDocument', id).then(() => {

          this.FBM.data.EngravingFile.removeDownloadFile(index)
          // this.FBM.data.EngravingFile.setDownloadFiles([])

          this.calculateEngravingPrice()
        })

        this.$store.commit('setConfirmDeletePopup', false)
        return true
      }

      this.deleteFunc(text, confirm)


    },
  },

}
</script>

<style scoped>

</style>